import React from 'react'
import { Quote, Star } from 'lucide-react'

const TestimonialCard = ({testi}) => {
  return (
    <div className='w-[520px] max-md:w-screen  h-[100%] mb-10 shadow-[12px]  p-3 rounded-sm  select-none mt-5 '>
        <Quote className='text-slate-400'/>
        <p className='italic text-xl'>"{testi.review}"</p>
        <p className='flex items-center justify-center'><Star className='fill-yellow-500 text-yellow-500 text-center'/> {testi.rating}</p>
        <p className='text-md font-medium'>{testi.name}</p>
        <p className='text-sm '>{testi.role}</p>
    </div>
  )
}

export default TestimonialCard